// Core
import React, { Component } from 'react'
import { connect } from 'react-redux'
import css from './styles.scss'

export class TemplateInstructions extends Component {
  constructor () {
    super()
    this.state = {
      showInstructions: false
    }
  }

  componentDidMount () {

  }

  handleToggle = () => {
    this.setState({
      showInstructions: !this.state.showInstructions
    })
  }

  getTemplateById (id) {
    return this.props.templates.templates.find(template => {
      return template.id === id
    })
  }

  render () {
    const { showInstructions } = this.state
    const { templates, selected } = this.props.templates
    const list = []
    if (!templates || selected.length < 1) {
      return null
    }
    selected.forEach(id => {
      const selected = this.getTemplateById(id)
      if (selected && selected.instructions) {
        list.push(
          <div key={selected.instructions}>
            <h4 className={css.h4}>{selected.name}</h4>
            <p className={css.p}>{selected.instructions}</p>
          </div>
        )
      }
    })
    if (list.length === 0) {
      return null
    }
    return (
      <article>
        <h3 className={css.h3}>
          Template Instructions <span onClick={this.handleToggle} className={`${css.arrow} ${showInstructions ? css.openArrow : ''}`}>&#9654;</span>
        </h3>
        <div className={`${css.wrap} ${!showInstructions ? css.closed : ''}`}>
          {list}
        </div>
      </article>
    )
  }
}
const mapStateToProps = state => {
  const { templates } = state
  return {
    templates
  }
}

export default connect(mapStateToProps)(TemplateInstructions)



// WEBPACK FOOTER //
// /app/js/components/TemplateInstructions/index.js